// @Version: 1.0.1
import { Injectable } from '@angular/core';
import { TRANSLATE_PATH } from 'src/app/shared/shared.model';
import { IErrorCodes, IFieldItem } from '../field-item.model';
import { ErrorMessagesService } from 'src/app/shared/services/errorMessages/error-messages.service';

interface IToggleModel {
   value: string;
   label: string;
}

@Injectable()
export class FieldItemToggleService {

   private required_: boolean = false;
   private toggleButtons_: IToggleModel[] = [];
   private errorCodes_: IErrorCodes = {} as IErrorCodes;

   set required (value: boolean) {
      this.required_ = value;
   }
   get required (): boolean {
      return this.required_;
   }

   get toggleButtons (): IToggleModel[] {
      return this.toggleButtons_;
   }

   get errorCodes (): IErrorCodes {
      return this.errorCodes_;
   }

   constructor (private sErrorMessages: ErrorMessagesService) { }

   public reset (): void {
      this.required_ = false;
      this.toggleButtons_ = [];
      this.errorCodes_ = {} as IErrorCodes;
   }

   public createErrorMessages (errorMessage: string): boolean {
      this.errorCodes_ = this.sErrorMessages.setErrorCodes(errorMessage, TRANSLATE_PATH.FIELD_ITEM_ERROR);
      return true;
   }

   public createToggleButtons (fieldItem: IFieldItem): boolean {
      if (fieldItem.attribute_1 && fieldItem.attribute_3) {
         this.toggleButtons_.push({
            label: fieldItem.attribute_1,
            value: fieldItem.attribute_3
         });
      }
      
      if (fieldItem.attribute_2 && fieldItem.attribute_4) {
         this.toggleButtons_.push({
            label: fieldItem.attribute_2,
            value: fieldItem.attribute_4
         });
      }

      return true;
   }

   public transformAttribute (fieldItem: IFieldItem): boolean {
      if (!fieldItem.attribute_1 || !fieldItem.attribute_2 || !fieldItem.attribute_3 ||!fieldItem.attribute_4) return true;
      if (fieldItem.required) this.required = fieldItem.required;

      this.createErrorMessages(fieldItem.attribute_5 || '');
      return this.createToggleButtons(fieldItem);
   }
}